import type { RouteLocationNormalized } from '#vue-router'
import { useMfaInfo } from '~/composables/useMfaInfo'
import { useSupabaseUser } from '~/composables/useSupabaseUser'

export default async ({ name: routeName }: RouteLocationNormalized) => {
  const supabaseUser = useSupabaseUser()
  if (!supabaseUser.value) return

  if (routeName === 'auth-setup') {
    const { pendingUser } = useMfaInfo()
    // 初期設定済の場合はトップ画面へ遷移
    if (!pendingUser.value) {
      return await navigateTo('/') // TODO: マイページへ遷移させる
    }
  }
}
